import { createContext, useContext, useState, useCallback } from "react";
import { crearProductoBomUseCase } from "../../../core/productos/application/crearProductoBom.usecase.js";
//import { obtenerProductosBomUseCase } from "../servicios/productos/application/obtenerProductosBom.usecase.js";

import { obtenerProductosCompuestosUseCase } from "../../../core/productos/application/obtenerProductosCompuesto.usecase.js";

const ProductosBomContext = createContext();

export const useProductosBom = () => useContext(ProductosBomContext);

export function ProductosBomProvider({ children }) {
  // datos en memoria
  const [productosBom, setProductosBom] = useState([]);
  const [loading, setLoading] = useState(false);

  // 🔹 CARGAR
  // Esto asegura que la función no se re-crea en cada render, y evita loops infinitos en el useEffect que la llama
  const cargarProductosBom = useCallback(async (filtros = {}) => {
    setLoading(true);
    try {
      const data = await obtenerProductosCompuestosUseCase(filtros);
      setProductosBom(data || []);
    } catch (e) {
      console.error(
        "[error ProductosBomContext ]Error cargando productos BOM",
        e,
      );
    } finally {
      setLoading(false);
    }
  }, []);

  // 🔹 CREAR (INSERT)
  const agregarProductoBom = useCallback(async (bomData) => {
    setLoading(true);
    try {
      const resultado = await crearProductoBomUseCase(bomData);

      if (!resultado.success) {
        return { success: false, error: resultado.error };
      }

      // 🔥 Agregamos al estado local sin recargar todo
      setProductosBom((prev) => [...prev, resultado.data[0]]);

      return { success: true, data: resultado.data };
    } catch (e) {
      console.error("Error creando BOM", e);
      return { success: false, error: e.message };
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <ProductosBomContext.Provider
      value={{
        productosBom,
        loading,
        cargarProductosBom,
        agregarProductoBom,
      }}
    >
      {children}
    </ProductosBomContext.Provider>
  );
}
